(() => {
  const root = document.documentElement;
  if (root.hasAttribute('data-ev-input')) return;
  root.dataset.evInput = 'keyboard';
  document.addEventListener('pointerdown', () => { root.dataset.evInput = 'pointer'; }, {capture:true, passive:true});
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow')) root.dataset.evInput = 'keyboard';
  }, {capture:true});
})();
